import React from 'react';

import { Distance as Wrapper } from './wrappers';

interface IDistance {
  className?: string;
  line?: boolean | 'mobile' | 'desktop';
  size?: string | string[];
}

const mq = ['ltmd', 'md'];

const Distance = ({ className, line, size }: IDistance) => {
  const classList = className ? className.split(' ') : [];

  if (line === true) {
    classList.push('line');
  } else if (line === 'mobile') {
    classList.push('line-lt-md');
  } else if (line === 'desktop') {
    classList.push('line-md');
  }

  if (size && !Array.isArray(size)) {
    classList.push(`size-${size}`);
  } else if (size && Array.isArray(size)) {
    size.map((line, i) => {
      if (i === 0) {
        classList.push(`size-${line}`);
      } else {
        classList.push(`size-${line}-${mq[i]}`);
      }
    });
  }

  return <Wrapper className={classList.join(' ')} />;
};

export default Distance;
